import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SubmitAnswer3MutationVariables = Types.Exact<{
  input: Types.Answer3;
}>;


export type SubmitAnswer3Mutation = (
  { __typename?: 'Mutation' }
  & { submitAnswer3?: Types.Maybe<(
    { __typename?: 'submitAnswer3Response' }
    & Pick<Types.SubmitAnswer3Response, 'score' | 'correct'>
  )> }
);


export const SubmitAnswer3Document = gql`
    mutation SubmitAnswer3($input: Answer3!) {
  submitAnswer3(input: $input) {
    score
    correct
  }
}
    `;
export type SubmitAnswer3MutationFn = Apollo.MutationFunction<SubmitAnswer3Mutation, SubmitAnswer3MutationVariables>;

/**
 * __useSubmitAnswer3Mutation__
 *
 * To run a mutation, you first call `useSubmitAnswer3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAnswer3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAnswer3Mutation, { data, loading, error }] = useSubmitAnswer3Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitAnswer3Mutation(baseOptions?: Apollo.MutationHookOptions<SubmitAnswer3Mutation, SubmitAnswer3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAnswer3Mutation, SubmitAnswer3MutationVariables>(SubmitAnswer3Document, options);
      }
export type SubmitAnswer3MutationHookResult = ReturnType<typeof useSubmitAnswer3Mutation>;
export type SubmitAnswer3MutationResult = Apollo.MutationResult<SubmitAnswer3Mutation>;
export type SubmitAnswer3MutationOptions = Apollo.BaseMutationOptions<SubmitAnswer3Mutation, SubmitAnswer3MutationVariables>;